import { render } from "./EditCharter.vue?vue&type=template&id=25f36902&scoped=true"
import script from "./EditCharter.vue?vue&type=script&lang=js"
export * from "./EditCharter.vue?vue&type=script&lang=js"

import "./EditCharter.vue?vue&type=style&index=0&id=25f36902&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f36902"]])

export default __exports__